import { call, put, takeEvery } from "redux-saga/effects"

import { 
  GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS, 
  UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS 
} from "./actionTypes"

import { 
  getSyndiClicksDashboardStickyColumnsError, 
  getSyndiClicksDashboardStickyColumnsSuccess, 
  updateSyndiClicksDashboardStickyColumnsError, 
  updateSyndiClicksDashboardStickyColumnsSuccess 
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* onGetSyndiClicksDashboardStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_syndi_clicks_dashboards`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getSyndiClicksDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getSyndiClicksDashboardStickyColumnsError(error))
  }
}

function* onUpdateSyndiClicksDashboardStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_syndi_clicks_dashboards/${action?.payload?.user_col_pref_syndi_clicks_dashboard?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateSyndiClicksDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateSyndiClicksDashboardStickyColumnsError(error))
  }
}

function* userSyndiClicksDashboardColumnPreferenceSaga() {
  yield takeEvery(GET_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS, onGetSyndiClicksDashboardStickyColumns)
  yield takeEvery(UPDATE_SYNDI_CLICKS_DASHBOARD_STICKY_COLUMNS, onUpdateSyndiClicksDashboardStickyColumns)
}

export default userSyndiClicksDashboardColumnPreferenceSaga;
